import { render } from "./CashierCustomization.vue?vue&type=template&id=5894cebf&scoped=true"
import script from "./CashierCustomization.vue?vue&type=script&lang=js"
export * from "./CashierCustomization.vue?vue&type=script&lang=js"

import "./CashierCustomization.vue?vue&type=style&index=0&id=5894cebf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5894cebf"]])

export default __exports__